var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75859 10.577C6.40529 7.72703 8.95521 5.6 12 5.6C14.3225 5.6 16.3573 6.83696 17.4794 8.69088L15.4443 8.0382C15.0236 7.90327 14.5731 8.13495 14.4382 8.55567C14.3033 8.97639 14.535 9.42683 14.9557 9.56176L18.9557 10.8446C19.199 10.9227 19.465 10.8798 19.6715 10.7292C19.8779 10.5786 20 10.3384 20 10.0828V5.59998C20 5.15815 19.6418 4.79998 19.2 4.79998C18.7582 4.79998 18.4 5.15815 18.4 5.59998V7.19942C16.9411 5.25755 14.6179 4 12 4C8.19173 4 5.00669 6.6602 4.19826 10.223C4.10049 10.6538 4.37052 11.0824 4.80139 11.1802C5.23227 11.2779 5.66082 11.0079 5.75859 10.577Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8018 13.777C19.8995 13.3462 19.6295 12.9176 19.1986 12.8198C18.7677 12.7221 18.3392 12.9921 18.2414 13.423C17.5947 16.273 15.0448 18.4 12 18.4C9.65097 18.4 7.5962 17.1346 6.48245 15.2452L9.40597 15.9761C9.83461 16.0832 10.269 15.8226 10.3761 15.394C10.4833 14.9654 10.2227 14.531 9.79403 14.4239L4.99403 13.2239C4.75504 13.1641 4.50184 13.2178 4.30767 13.3694C4.1135 13.521 4 13.7536 4 14V18.4C4 18.8418 4.35817 19.2 4.8 19.2C5.24183 19.2 5.6 18.8418 5.6 18.4L5.6 16.8006C7.05889 18.7424 9.38208 20 12 20C15.8083 20 18.9933 17.3398 19.8018 13.777Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.42a50ddbdfe6a76c07eea10460ec68ad.svg";
export { ForwardRef as ReactComponent };